module.exports = __webpack_public_path__ + "static/3.5675ea59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling/3.png
// module id = 883
// module chunks = 230667518368419 245178253630338